import ScrollArea from 'react-scrollbar';
export default ScrollArea;
